import {default as _} from 'lodash';
import { Component, ViewChild, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { HttpErrorResponse } from '@angular/common/http';
import {default as GridColumnsJSON} from './catalyst-comment-viewer-grid-columns.json';
import { ConstantService } from "app/Shared/Services/constant-service";
import { GridService } from "app/Shared/Services/grid.service";
import { UserService } from "app/Shared/Services/user.service";
import { DataService } from 'app/Shared/Services/data.service';
import { CatAnalyticsService } from "app/Pages/cat-dashboard/cat/cat-analytics/cat-analytics.service";
import { CatalystCommentViewerService } from "./catalyst-comment-viewer.service";
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { TableModule,Table } from 'primeng/table';
import { MessageService,ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { DatePipe, LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { DatepickerCalendarComponent } from '../datepicker-calendar/datepicker-calendar.component';
import { DatepickerService } from '../datepicker-calendar/datepicker.service';

@Component({
    selector: 'app-catalyst-comment-viewer',
    templateUrl: './catalyst-comment-viewer.component.html',
    styleUrls: ['./catalyst-comment-viewer.component.scss'],
    imports: [TableModule, ToastModule, NgClass, CommonModule, DialogModule, ButtonModule, MatTooltipModule,
        ConfirmDialogModule, FormsModule, MatProgressSpinner, MatExpansionModule, MatChipsModule,
        DatePipe, LowerCasePipe, DatepickerCalendarComponent
    ]
})
export class CatalystCommentViewerComponent implements OnInit {
  @ViewChild(('dt')) dt!: Table | any; 
  @Output() reloadCommentCount: EventEmitter<any> = new EventEmitter();
  @Input('selectedRow') selectedRow: any = [];
  @Input('dailyVariance') dailyVariance!:number;
  cols :any= [];
  tbldatamsg = 'L o a d i n g . . . . .';
  isDataLoading: boolean = true;
  gridColumns: any = GridColumnsJSON;
  filterReportDate: any = [];
  todate: string = "";
  staticFilters: any = [];
  staticAvailableFilters: any = [];
  DefaultFilterArray: any = [];
  LastExecutionDate!: any[];
  catalystCommentData: any = [];
  isOpenDateRangeFilter: boolean | any = false;
  rowcount: number = 5;
  totalRecords : number = 0;
  startLimit: any = 0;
  endLimit!: number;
  pageNumber: any = 1;
  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  rowsPerPageOptions: any = [];
  sortData:any = { field: '', order: 0};
  sortClickCounter: number = 0;
  commentStatement: any;
  maxCharsLength: number = 256;

  constructor(public gridService: GridService,
    public constantService: ConstantService,
    public userService: UserService,
    public messageService: MessageService,
    public dataService: DataService,
    private confirmationService: ConfirmationService,
    public catAnalyticsService: CatAnalyticsService,
    public CatalystCommentViewerService: CatalystCommentViewerService,
    private datepickerService: DatepickerService,
    private sortPipe: SortPipe) {
      this.staticFilters = [{filterName: 'Report Date', filterValue: '', fieldName: 'optedDay'}, {filterName: 'Group', filterValue: '', fieldName: 'groupName'}, {filterName: 'Asset Class', filterValue: '', fieldName: 'assetClass'}, {filterName: 'Field Name', filterValue: '', fieldName: 'fieldName'}, {filterName: 'Field Value', filterValue: '', fieldName: 'fieldValue'}, {filterName: 'Event Type', filterValue: '', fieldName: 'eventType'}, {filterName: 'Avg Type', filterValue: '', fieldName: 'optedDay'}];
  }

  ngOnInit() {
    this.isDataLoading = false;
    /* Dynamically Add Rows Per Page for CAT Recon Comment Viewer Screen only */
    this.rowsPerPageOptions = [5, 10, ...this.constantService.DEFAULT_ROWSPERPAGEOPTION];

    let todate: any;
    todate = this.userService.getyyyyMMddDateFormate(this.userService.CATAnalyticsLastExecutionReportDate);
    this.LastExecutionDate = [];
    if (todate != "" || todate != undefined || todate != null) {
      this.LastExecutionDate[0] = (todate);// Fromdate
      this.LastExecutionDate[1] = (todate);// Todate
      this.endLimit = this.rowcount;
      this.Limit = { 'Start': '0', 'End': this.endLimit };
      this.defaultFilter();
      this.getColumns();
      this.getData();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['selectedRow']) {
      this.getFiltersAvailability();
    }
    if(changes['selectedRow'] && !changes['selectedRow'].firstChange) {
      this.getData();
    }
  }

  getFiltersAvailability() {
    // Filter for Report Date
    let reportDateIndex = this.staticFilters.findIndex((Obj:any)=>Obj.filterName==="Report Date");
    this.staticFilters[reportDateIndex]["filterValue"] = "";
    // Filter for AverageType
    let avgTypeIndex = this.staticFilters.findIndex((Obj:any)=>Obj.filterName==="Avg Type");
    this.staticFilters[avgTypeIndex]["filterValue"] = "";
    if(!this.catAnalyticsService.isDisplayDateRangeFilter && reportDateIndex!==-1 && this.selectedRow && this.selectedRow.optedDay && this.selectedRow.optedDay.length===1) {
      if(!_.includes(['average5Days', 'average30Days'], this.selectedRow.optedDay[0])) {
        this.staticFilters[reportDateIndex]["filterValue"] = this.selectedRow.optedDay[0];
      } else {
        this.staticFilters[reportDateIndex]["filterValue"] = this.selectedRow.reportDate;
        if(!this.catAnalyticsService.isDisplayDateRangeFilter && avgTypeIndex!==-1 && this.selectedRow && this.selectedRow.optedDay && this.selectedRow.optedDay.length===1) {
          this.staticFilters[avgTypeIndex]["filterValue"] = (_.includes(['average5Days'], this.selectedRow.optedDay[0]) ? '5 Day' : (_.includes(['average30Days'], this.selectedRow.optedDay[0]) ? '30 Day' : ''));
        }
      }
    }
    /* Filters except Report Date/Average Type */
    for(let i=0; i<this.staticFilters.length; i++) {
      if(!_.includes(["Report Date", "Avg Type"], this.staticFilters[i]["filterName"])) {
        // Field Filter
        let fieldIndex = this.staticFilters.findIndex((Obj:any)=>Obj.filterName===this.staticFilters[i]["filterName"]);
        this.staticFilters[fieldIndex]["filterValue"] = "";
        if(fieldIndex!==-1 && this.selectedRow && this.selectedRow[this.staticFilters[i]["fieldName"]]) {
          this.staticFilters[fieldIndex]["filterValue"] = this.selectedRow[this.staticFilters[i]["fieldName"]];
        }
      }
    }

    this.staticAvailableFilters = this.staticFilters.filter((obj:any) => obj.filterValue);
  }

  getResolutionWidth() {
    return window.innerWidth - 400;
  }

  getColumns() {
    let column: any = this.gridColumns;
    if (column != null || column != undefined) {
      this.cols = this.gridService.getGridColumns(column);
    }
  }
  
  defaultFilter() {
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'reportDate', 'filterby': '', 'values': this.LastExecutionDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
    ];
  }

  onSelectionChange(selection: any[]) {
    for (let i = selection.length - 1; i >= 0; i--) {
      let data = selection[i];
      if(!data.isActive) {
        selection.splice(i, 1);
      }
    }
    this.dataService.roeSelectedRecords = selection;
  }

  changePage(event:any) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;

    this.getData();
  }

  sort(event:any) {
    if(this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    }
    if(this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.catalystCommentData = this.sortPipe.transform(this.catalystCommentData, this.sortData.order, this.sortData.field);
    } else {
      this.dt.multiSortMeta[0].field = '';
      this.dt.multiSortMeta[0].order = 0;
    }
  }

  getData() {
    this.dataService.roeSelectedRecords = [];
    this.catalystCommentData = [];
    this.isDataLoading = true;
    this.previousLimit = this.Limit;
    this.tbldatamsg = 'L o a d i n g . . . . .';

    const filterParams = this.prepareSearchParameters();
    Object.assign(filterParams, {startLimit: this.Limit.Start.toString(), endLimit: this.Limit.End.toString()});

    /* set post dataset */
    this.CatalystCommentViewerService.getCatalystComments(filterParams)
    .subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
          this.catalystCommentData = dataset.Data;
          this.totalRecords = dataset.totalCount;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          if (dataset.Data.length === 0) {
            this.tbldatamsg = "No data found";
          }
          this.isDataLoading = false;
      },
      error: (err: HttpErrorResponse) => {
        this.isDataLoading = false;
      }
    });
  }

  prepareSearchParameters() {
    this.LastExecutionDate = [];
    let averageType;
    if(this.catAnalyticsService.isDisplayDateRangeFilter && this.filterReportDate.length > 0) {
      this.LastExecutionDate.push(this.userService.getyyyyMMddDateFormate(this.filterReportDate[0]));
      this.LastExecutionDate.push(this.userService.getyyyyMMddDateFormate(this.filterReportDate[1]));
    } else if(this.catAnalyticsService.isDisplayDateRangeFilter && this.filterReportDate.length===0) {
      this.LastExecutionDate.push((this.selectedRow.optedDay[this.selectedRow.optedDay.length-1] ? this.selectedRow.optedDay[this.selectedRow.optedDay.length-1] : this.selectedRow.reportDate));
      this.LastExecutionDate.push(this.selectedRow.reportDate);
    } else if(this.selectedRow.optedDay && this.selectedRow.optedDay.length===1 && _.includes(['average5Days', 'average30Days'], this.selectedRow.optedDay[0])) {
      this.LastExecutionDate.push(this.selectedRow.reportDate);
      this.LastExecutionDate.push(this.selectedRow.reportDate);
      averageType = (_.includes(['average5Days'], this.selectedRow.optedDay[0]) ? '5 Day' : (_.includes(['average30Days'], this.selectedRow.optedDay[0]) ? '30 Day' : ''));
    } else if(this.selectedRow.optedDay && this.selectedRow.optedDay.length===1 && !_.includes(['average5Days', 'average30Days'], this.selectedRow.optedDay[0])) {
      this.LastExecutionDate.push(this.selectedRow.optedDay[0]);
      this.LastExecutionDate.push(this.selectedRow.optedDay[0]);
    }

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    filterData[0].values[0] = this.LastExecutionDate[0];
    filterData[0].values[1] = this.LastExecutionDate[1];

    let filterParams = {
      CATReporterIMID: this.userService.getActiveMPID(),
      groupName: this.selectedRow.groupName,
      fieldName: this.selectedRow.fieldName,
      fieldValue: this.selectedRow.fieldValue,
      eventType: this.selectedRow.eventType,
      assetClass: this.selectedRow.assetClass,
      optedDay: this.selectedRow.optedDay,
      avgType: averageType,
      reportDate: this.selectedRow.reportDate,
      user: this.userService.getUserName(),
      userName: this.userService.getUserFirstName(),
      data: filterData
    };

    return filterParams;
  }

  addAnalyticalComment() {
    let filterData = {
      CATReporterIMID: this.userService.getActiveMPID(),
      groupName: this.selectedRow.groupName,
      fieldName: this.selectedRow.fieldName,
      fieldValue: this.selectedRow.fieldValue,
      eventType: this.selectedRow.eventType,
      assetClass: this.selectedRow.assetClass,
      optedDay: this.selectedRow.optedDay,
      avgType: (this.selectedRow.optedDay.length===1 && _.includes(['average5Days', 'average30Days'], this.selectedRow.optedDay[0]) ? (_.includes(['average5Days'], this.selectedRow.optedDay[0]) ? '5 Day' : (_.includes(['average30Days'], this.selectedRow.optedDay[0]) ? '30 Day' : '')) : ''),
      reportDate: (this.selectedRow.optedDay.length===1 && _.includes(['average5Days', 'average30Days'], this.selectedRow.optedDay[0]) ? this.selectedRow.reportDate : this.selectedRow.optedDay[0]),
      user: this.userService.getUserName(),
      userName: this.userService.getUserFirstName(),
      commentStatement: this.commentStatement,
      dailyVariance:this.dailyVariance
    };
    this.isDataLoading = true;
    this.CatalystCommentViewerService.addCatalystComment(filterData)
    .subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
          this.messageService.add({ severity: 'success', summary: 'Add Message', detail: dataset.message });
          this.getData();
          this.commentStatement = '';
          this.reloadCommentCount.emit(); // Reload All Comment Counts at Parent CAT Analytics Component
      },
      error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Comment hasn\'t been Added' });
        this.isDataLoading = false;
      }
      });
  }

  showDateFilter() {
    this.isOpenDateRangeFilter = true;
  }

  applyFilter() {
    let fromdate = this.userService.getyyyyMMddDateFormate(this.filterReportDate[0]);
    let todate = this.userService.getyyyyMMddDateFormate(this.filterReportDate[1]);

    this.LastExecutionDate = [];
    if ((fromdate != "" || fromdate != undefined || fromdate != null) && (todate != "" || todate != undefined || todate != null)) {
      this.LastExecutionDate[0] = (fromdate);// Fromdate
      this.LastExecutionDate[1] = (todate);// Todate
    }

    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.getData();
  }

  removeRecords(e:any) {
    let msg = '';
    if(this.dataService.roeSelectedRecords.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'User Action', detail: 'Please select any record to perform action' });
      return false;
    }
    if (this.dataService.roeSelectedRecords.length > 1) {
      msg = 'Are you sure that you want to delete All?';
    } else {
      msg = 'Are you sure that you want to delete?';
    }
    this.confirmationService.confirm({
      message: msg,
      acceptIcon:'pi pi-check',
      rejectIcon:'pi pi-times',
      key: 'DeleteconfirmationDialoge',
      accept: () => {
        let filterData = {
          CATReporterIMID: this.userService.getActiveMPID(),
          user: this.userService.getUserName(),
          userName: this.userService.getUserFirstName(),
          selectedRows: this.dataService.roeSelectedRecords
        };
        this.isDataLoading = true;
        this.CatalystCommentViewerService.deleteCatalystComment(filterData)
          .subscribe({
            next: (Element: any) => {
              let dataset: any = Element;
              this.messageService.add({ severity: 'success', summary: 'Add Message', detail: dataset.message });
              this.getData();
            },
            error: (err: HttpErrorResponse) => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Comment hasn\'t been Deleted' });
              this.isDataLoading = false;
            }
          });
        }
    });
    return;
  }

  exportToCSV() {
    if(this.userService.enableFileExport()){
    const filterParams = this.prepareSearchParameters();
    this.CatalystCommentViewerService.exportCSV(this.gridColumns, filterParams);
    }
  }

  closeDialogbox() {
    this.filterReportDate = [];
    this.commentStatement = "";
    this.dataService.roeSelectedRecords = [];
    this.catAnalyticsService.isOpenCommentViewer = false;
    /* Reset Pagination */
    this.totalRecords = 0;
    this.pageNumber = 1;
    this.dt.first = 1;
    this.Limit = { 'Start': '0', 'End': this.rowcount };
  }
  getDateEmitter(){
    this.filterReportDate[0]=this.datepickerService.dateRange[0];
    this.filterReportDate[1]=this.datepickerService.dateRange[1];
  }

}